import React from 'react'

import IconBase, { IconProps } from './IconBase'

const IconCheckmarkCircle = ({ size, className }: IconProps) => (
  <IconBase size={size} className={className}>
    <path
      d="m4.1411 12c0-4.3404 3.5186-7.8589 7.8589-7.8589 1.256 0 2.4412 0.2941 3.4924 0.81653 0.35341 0.17559 0.78218 0.031502 0.95774-0.32185 0.17566-0.35335 0.03153-0.78215-0.32179-0.95775-1.2445-0.61843-2.6469-0.96582-4.1284-0.96582-5.1295 0-9.2878 4.1583-9.2878 9.2878 0 5.1295 4.1583 9.2878 9.2878 9.2878 5.1295 0 9.2878-4.1583 9.2878-9.2878 0-0.34827-0.01924-0.69235-0.05668-1.0311-0.04334-0.39218-0.39638-0.67501-0.78856-0.63167-0.39218 0.04344-0.67501 0.39647-0.63167 0.78866 0.03172 0.28673 0.04801 0.57842 0.04801 0.8741 0 4.3403-3.5186 7.8589-7.8589 7.8589-4.3404 0-7.8589-3.5186-7.8589-7.8589zm16.937-6.163c0.27902-0.27901 0.27902-0.73138 0-1.0104-0.27902-0.27901-0.73131-0.27901-1.0103 0l-8.0682 8.0681-2.3526-2.3525c-0.27901-0.27902-0.73138-0.27902-1.0104 0s-0.27901 0.73131 0 1.0103l2.8578 2.8578c0.13394 0.13403 0.31569 0.20928 0.50516 0.20928s0.37123-0.07526 0.50516-0.20928z"
      clipRule="evenodd"
      fillRule="evenodd"
      strokeWidth=".9526"
    />
  </IconBase>
)

export default IconCheckmarkCircle
